module.exports = __webpack_public_path__ + "media/images/2024_fanclub_card_sponser2-93e2b0dd39e94cd336e2bd90118fd006.png";